<template>
    <div class="guide_mo">
        <!-- 右侧滑出筛选面板 -->
        <transition name="filter_slide">
            <div v-if="showFilter" class="filter_overlay" @click.self="showFilter = false">
                <div class="filter_wrap">
                    <!-- 左侧分类标签 -->
                    <div class="nav_tabs">
                        <div v-for="cat in CATEGORIES" :key="cat.key" class="nav_category">
                            <div
                                class="nav_category_header"
                                :class="{ active: activeCategory === cat.key }"
                                @click="toggleCategory(cat.key); showFilter = false"
                            >
                                <span class="nav_icon">
                                    <img :src="`../../../static/guide/pc/${cat.icon}.png`" alt="">
                                </span>
                                <span class="nav_label">{{ getCategoryLabel(cat) }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- 右侧筛选面板 -->
                    <div class="filter_panel">
                    <!-- 暂无筛选（英雄） -->
                    <div v-if="!RARITY_CONFIG[activeCategory]" class="filter_title">
                        {{ t.noFilters }}
                    </div>
                    <!-- 稀有度筛选 -->
                    <div v-if="RARITY_CONFIG[activeCategory]" class="filter_section">
                        <div class="filter_title">
                            {{ t.rarity }}
                            <span class="sort_icon" @click.stop="toggleSort">
                                <img
                                    :src="sortAsc
                                        ? '../../../static/guide/pc/nav_title_icon.png'
                                        : '../../../static/guide/pc/nav_title_icon_top.png'"
                                    alt=""
                                >
                            </span>
                        </div>
                        <div class="filter_options">
                            <div
                                v-for="(info, rarity) in RARITY_CONFIG[activeCategory]"
                                :key="rarity"
                                class="filter_checkbox"
                                @click="toggleRarity(Number(rarity))"
                            >
                                <img
                                    class="check_icon"
                                    :src="selectedRarities.includes(Number(rarity))
                                        ? '../../../static/guide/pc/check_icon_hover.png'
                                        : '../../../static/guide/pc/check_icon.png'"
                                />
                                <span :style="{ color: info.color }">{{ getRarityLabel(Number(rarity)) }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- 构筑类型筛选（仅宝物） -->
                    <div v-if="activeCategory === 'treasures' && treasureTypes.length" class="filter_section">
                        <div class="filter_title">
                            {{ t.buildType }}
                        </div>
                        <div class="filter_options">
                            <div
                                v-for="type in treasureTypes"
                                :key="type.typeId"
                                class="filter_checkbox"
                                @click="toggleType(type.typeId)"
                            >
                                <img
                                    class="check_icon"
                                    :src="selectedTypes.includes(type.typeId)
                                        ? '../../../static/guide/pc/check_icon_hover.png'
                                        : '../../../static/guide/pc/check_icon.png'"
                                />
                                <span>{{ type.name }}</span>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </transition>

        <!-- 卡片网格 -->
        <div class="guide_content">
            <div class="guide_grid" :class="`grid_${activeCategory}`">
                <div
                    v-for="(item, idx) in currentItems"
                    :key="item.itemId"
                    class="guide_card"
                    :class="`card_${activeCategory}`"
                    @click="openDetail(idx)"
                >
                    <div class="card_frame" :style="getRarityBgStyle(item)">
                        <div class="card_image">
                            <img :src="getIconUrl(item.icon)" :alt="item.name" loading="lazy" decoding="async" @load="$event.target.classList.add('loaded')" />
                        </div>
                    </div>
                    <div class="card_name">{{ item.name }}</div>
                </div>
            </div>
        </div>

        <!-- 卡牌详情弹窗 -->
        <div v-if="showDetail && detailItem" class="detail_overlay" @click.self="closeDetail">
            <div class="detail_modal" :class="`detail_${activeCategory}`">
                <div class="detail_close" @click="closeDetail">
                    <img src="../../../static/guide/pc/detail_close.png" alt="">
                </div>
                <div class="detail_body">
                    <div class="detail_card_wrap detail_card_main">
                        <div class="guide_card" :class="`card_${activeCategory}`">
                            <div class="card_frame" :style="getRarityBgStyle(detailItem)">
                                <div class="card_image">
                                    <img :src="getIconUrl(detailItem.icon)" :alt="detailItem.name" @load="$event.target.classList.add('loaded')" />
                                </div>
                            </div>
                            <div class="card_name">{{ detailItem.name }}</div>
                        </div>
                    </div>
                    <div class="detail_info">
                        <div v-if="detailItem.desc">
                            <span class="detail_label">{{ t.effect }}:</span>
                            &nbsp;
                            <span v-html="formatDesc(detailItem.desc)"></span>
                        </div>
                        <div v-if="detailItem.rarity !== undefined">
                            <span class="detail_label">{{ t.rarity }}:</span>
                            &nbsp;
                            <span>{{ getDetailRarityLabel(detailItem) }}</span>
                        </div>
                        <div v-if="detailItem.derivantId" class="isSynthesis">
                            <span class="detail_label">{{ t.combineable }}</span>
                        </div>
                    </div>
                </div>
                <!-- 衍生卡牌 -->
                <div v-if="detailItem.derivantId" class="detail_derivant">
                    <div class="detail_derivant_title">{{ t.canCombineInto }}:</div>
                    <div class="detail_derivant_body">
                        <div class="detail_card_wrap detail_card_sub">
                            <div class="guide_card" :class="`card_${activeCategory}`">
                                <div class="card_frame" :style="getRarityBgStyle({ rarity: detailItem.derivantRarity, mergeLevel: detailItem.derivantMergeLevel })">
                                    <div class="card_image">
                                        <img :src="getIconUrl(detailItem.derivantIcon)" :alt="detailItem.derivantName" @load="$event.target.classList.add('loaded')" />
                                    </div>
                                </div>
                                <div class="card_name">{{ detailItem.derivantName }}</div>
                            </div>
                        </div>
                        <div class="detail_derivant_desc" v-html="formatDesc(detailItem.derivantDesc)"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import guideLogic from './logic.js'

export default {
    mixins: [guideLogic],
    data() {
        return {
            showFilter: false
        }
    }
}
</script>

<style scoped lang="less">
@import "./mobile.less";
</style>



// WEBPACK FOOTER //
// src/pages/guide/GuideMobile.vue